// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html .cog-lookup--loading:focus,:root:root:root:root:root .cog-lookup--loading:focus{box-shadow:inset 0 0 0 var(--input__border-width) hsla(var(--background-hsl), 1)}", ""]);
// Exports
module.exports = exports;
